import Image from 'next/image';
import type { Image as ImageType } from '@/types/bookmaker';

export function SectionImagesList({
  images,
  imageAltPrefix,
}: {
  images: ImageType<unknown>[];
  imageAltPrefix: string;
}) {
  return (
    <div className="flex flex-wrap justify-center gap-2">
      {images.map((image, index) => (
        <div className="h-[101px] w-[156px] object-fill" key={image.id}>
          <Image
            alt={`${imageAltPrefix}-${index + 1}`}
            className="h-full rounded-lg"
            height={0}
            src={image.attributes.url}
            width={156}
          />
        </div>
      ))}
    </div>
  );
}
